// extracted by mini-css-extract-plugin
export default {"thumb":"gYcJdBO8m2HdK8J7myHd"};